export default "__VITE_ASSET__2e526bf2__"